import React from "react";
import ReactDOM from "react-dom";
import { bool, func, node } from "prop-types";

class ClickOutsideDetector extends React.Component {
  static propTypes = {
    /**
     * Children to render.
     */
    children: node,
    /**
     * Disable the triggering of `onClickOutside`.
     */
    isDisabled: bool,
    /**
     * Callback fired after click outside of the element.
     *
     * @param {SyntheticEvent} event The click event outside the component
     */
    onClickOutside: func
  };

  static defaultProps = {
    children: null,
    isDisabled: false,
    onClickOutside: () => {}
  };

  componentDidMount() {
    const { isDisabled } = this.props;

    if (!isDisabled) {
      this.addEventListeners();
    }
  }

  componentDidUpdate(prevProps) {
    const { isDisabled } = this.props;
    const { isDisabled: wasDisabled } = prevProps;

    if (!isDisabled && wasDisabled) {
      this.addEventListeners();
    } else if (isDisabled && !wasDisabled) {
      this.removeEventListeners();
    }
  }

  componentWillUnmount() {
    const { isDisabled } = this.props;

    if (!isDisabled) {
      this.removeEventListeners();
    }
  }

  addEventListeners = () => {
    document.addEventListener("mousedown", this.handleClick);
  };

  removeEventListeners = () => {
    document.removeEventListener("mousedown", this.handleClick);
  };

  handleClick = event => {
    const { onClickOutside } = this.props;
    /* eslint-disable react/no-find-dom-node */
    const componentNode = ReactDOM.findDOMNode(this);
    /* eslint-enable react/no-find-dom-node */
    if (!componentNode.contains(event.target)) {
      onClickOutside(event);
    }
  };

  render() {
    const { children } = this.props;
    return children;
  }
}

export default ClickOutsideDetector;
